import { Injectable } from 'angular-ts-decorators';

import { SpynlBase } from '@shared/app/scripts/services/spynl-base';
import { Domain } from '@shared/app/scripts/services/domain';
import type { IConfig } from '@shared/app/scripts/services/config';

/**
 * Service in the coreModule. It takes care of communication with secondScreen
 * resource. Methods are inherited form {@link shared.spynlBase
 * spynlBase} service, and are documented there.
 */
@Injectable('secondScreen')
export class SecondScreen extends SpynlBase<Object> {
  protected location: string;

  constructor(
    $http: ng.IHttpService,
    $q: ng.IQService,
    sentry,
    domain: Domain,
    config: IConfig,
    standardErrorParser,
  ) {
    'ngInject';

    super($http, $q, sentry, domain, config, standardErrorParser, Object);
    this.location = '/pos_secondscreen';
  }
}
